module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAC9BQwsAAAA1ElEQVQ4je2UMQoCMRBFX8RiYS0sPYGdgkRsLLQRsfAQnsLOuFewFdxLrAfQ2oCIB/AEYqGlxEaXYVnNItj5m2Q+eUwmmUQ551CRnQA9imnjjI4V810A3IA1cPZANWAAhGUgAErAzBm9/0SpyPaBIRCUhR+qyFY9GSuviQRXQN0DppLgFDh51reBZRY8FagxLaVUdGtZ/cFfgPIeWwVarpEHLhC9+Ea3PHAEHEXcfI4H4XWBJAtendGXV6Ai2wFwRm+Fl2b8+iEr8XWM8Z/yHUic0fEDaGU4DSLj3ugAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 1